import React, { ReactNode } from 'react';

import classNames from 'classnames';

import { Separator } from '@/blocks/components/Separator';
import typography from '@/styles/typography.module.scss';

import { WithClassName } from '../../types';
import styles from './InfoBusinessCardContent.module.scss';

export function InfoBusinessCardContent({
  icon,
  title,
  subheading,
  titleTypography,
  withSeparator,
  children,
  className,
  subheadingClassName,
}: {
  icon?: ReactNode;
  title: ReactNode;
  subheading?: ReactNode;
  titleTypography?: string;
  withSeparator?: boolean;
  children: ReactNode;
  subheadingClassName?: string;
} & WithClassName) {
  return (
    <>
      <div className={classNames(styles.cardHeading, className)}>
        {icon}
        <p className={classNames(titleTypography ? titleTypography : typography.h4, styles.title)}>{title}</p>
      </div>
      {subheading && (
        <div className={classNames(typography.bodyM, styles.subheading, subheadingClassName)}>
          {subheading}
        </div>
      )}
      {withSeparator && <Separator className={styles.separator} />}
      <div className={styles.cardContent}>{children}</div>
    </>
  );
}
